import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import HeroSection from "./components/HeroSection";
import DiagonalDivider from "./components/DiagonalDivider";
import BackgroundSection from "./components/BackgroundSection";
import Stapelbehälter from "./assets/KeyVisual_2_Stapelbehälter_Ausschnitt.jpg";
import "./App.css";
import DiagonalDivider2 from "./components/DiagonalDivider2";
import ClosingSection from "./components/ClosingSection";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function HomePage() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#d9e0e4",
      }}
    >
      <HeroSection />
      <DiagonalDivider />
      <BackgroundSection src={Stapelbehälter} alt="Second background" />
      <DiagonalDivider2 />
      <ClosingSection />
    </div>
  );
}

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
      </Routes>
    </>
  );
}
